module.exports = __webpack_public_path__ + "static/img/icon20.97abfc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon20.png
// module id = juHC
// module chunks = 0